import React from 'react';
import { Switch, Route, RouteComponentProps } from 'react-router-dom';
import { Tabs } from 'antd';
import List from './List';
import ContentWrapper from '../../Components/ContentWrapper';
import Form from './Form';
import PageHeader from '../../Components/PageHeader';
import { ContractStatus } from '../../types';

class Contractors extends React.Component {
  render(): React.ReactElement {
    return (
      <Switch>
        <Route
          path="/contractors"
          exact
          render={(props: RouteComponentProps): React.ReactElement => (
            <>
              <PageHeader title="Contractors" />
              <ContentWrapper>
                <Tabs defaultActiveKey="active">
                  <Tabs.TabPane tab="Active" key="active">
                    <List status={ContractStatus.OPEN} history={props.history} />
                  </Tabs.TabPane>
                  <Tabs.TabPane tab="Pending" key="pending">
                    <List status={ContractStatus.DRAFT} history={props.history} />
                  </Tabs.TabPane>
                  <Tabs.TabPane tab="Expired" key="expired">
                    <List status={ContractStatus.CLOSE} history={props.history} />
                  </Tabs.TabPane>
                  <Tabs.TabPane tab="Cancelled" key="cancelled">
                    <List status={ContractStatus.CANCEL} history={props.history} />
                  </Tabs.TabPane>
                </Tabs>
              </ContentWrapper>
            </>
          )}
        />
        <Route path="/contractors/:id" component={Form} />
      </Switch>
    );
  }
}

export default Contractors;
